import React from 'react';

import { get } from 'lodash';
import { FieldErrors, useFormContext } from 'react-hook-form';

import { FieldError, FieldWrapper, Label } from 'styles/form';

interface FieldProps {
  children: React.ReactNode;
  name?: string;
  label?: string;
  required?: boolean;
}

// When using arrays in rhf, the error is nested under the index.
// This will retrieve the deep error based on the name as a path
const resolveFieldError = (errors: FieldErrors, name: string) => {
  const nameSplit = name.split('.');
  return get(errors, nameSplit);
};

export default function Field({ children, name, label, required }: FieldProps) {
  const {
    formState: { errors },
  } = useFormContext();

  // Not passing a name for the field will cause it to render a "dummy field"
  if (!name) {
    return <FieldWrapper>{children}</FieldWrapper>;
  }

  const error = !!errors && resolveFieldError(errors, name)?.message;

  return (
    <FieldWrapper error={!!error}>
      {label && (
        <Label>
          {label} {required && '*'}
        </Label>
      )}
      {children}
      <FieldError>{error && error}</FieldError>
    </FieldWrapper>
  );
}
